import Dialog from "../utils/Dialog";

class SpektrixIframe {
    constructor(element) {
        this.element = element;
        this.iframe = element.querySelector("iframe");
        this.uid = this.iframe.dataset.iframeUid;
        this.loadingIndicator = element.querySelector(
            ".spektrix-iframe__loading-indicator",
        );

        this.iframe.addEventListener("load", () => {
            this.loaded();
        });

        if (this.iframe.readyState === "complete") {
            this.loaded();
        }
    }

    loaded() {
        this.loadingIndicator &&
            this.loadingIndicator.setAttribute("active", false);
        this.iframe.classList.add("is-loaded");
    }
}

window.spekShowViewFromSeat = function (url, tooltip) {
    // console.log(url, tooltip);

    const dialogEl = document.querySelector(".view-from-seat-dialog");

    const dialog = new Dialog(dialogEl);

    const image = document.createElement("img");
    // image.src = `https://system.spektrix.com/newwolsey/files/${url}`;
    image.src = url;

    // dialog.content = image;

    dialog.contentSlot.innerHTML = image.outerHTML;

    dialog.open();
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".spektrix-iframe").forEach((element) => {
        new SpektrixIframe(element);
    });
});
